module.exports = __webpack_public_path__ + "04_long_gold.1b2e18db.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer5/04_long_gold.png
// module id = 2Xzg
// module chunks = 0